var map = {
	"./views/HK/m/shop/index": [
		"9c32",
		"chunk-2cd81fe9",
		"chunk-443ca35e"
	],
	"./views/m/shop/index": [
		"1ee7",
		"chunk-2cd81fe9",
		"chunk-36358b56"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "ff88";
module.exports = webpackAsyncContext;